<template>
<div :class='wrapperClass'
     class='fw-switcher'
     @click='toggleSwitch'>
    <div class='fw-switcher__slider'>
        <span class='fw-switcher__circle'>
            <FwRoundLoader
                v-if='isRequestSending'
                :size='16'>
            </FwRoundLoader>
        </span>
    </div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import FwRoundLoader from '../loaders/FwRoundLoader.vue';

@Component({
    components: {
        FwRoundLoader,
    },
})
export default class FwSwitcher extends Vue {
    @Prop({ type: Boolean, required: true }) readonly isActive!: boolean;
    @Prop({ type: Boolean, required: false }) readonly iconLeft!: boolean | string;
    @Prop({ type: Boolean, default: false }) readonly isRequestSending!: boolean;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

    get wrapperClass() {
        return {
            'fw-switcher--active': this.isActive,
            'fw-switcher--waiting': this.isRequestSending,
            'fw-switcher--disabled': this.disabled,
        };
    }

    toggleSwitch() {
        if (!this.isRequestSending && !this.disabled) {
            this.$emit('toggleSwitch');
        }
    }
}
</script>

<style lang='sass'>

</style>

<style lang='sass'>
.fw-switcher
    position: relative
    display: inline-block
    width: 33px
    height: 20px

    &--waiting
        .fw-switcher__circle
            transform: translateX(18px)

    &--active
        .fw-switcher__slider
            background-color: $aqua-marine
            .fw-switcher__circle
                transform: translateX(18px)
                background-color: #fff
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.14)
    &__slider
        position: absolute
        cursor: pointer
        top: 0
        left: 0
        right: 0
        bottom: 0
        transition: .4s
        border-radius: 17px
        border: 0.96px solid #E5E5E5
        background-color: transparent

    &__circle
        position: absolute
        height: 18px
        width: 18px
        left: -4px
        background-color: #fff
        transition: .4s
        border-radius: 50%
        top: 0
        bottom: 0
        margin: auto
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.14)
        display: flex
        align-items: center
        justify-content: center
</style>
